export default __webpack_public_path__ + "4cfd473a667e49e0c8815b811f1511f1.svg";